import React, { useState, useEffect } from 'react';
import { Button, PseudoStates, PageTitle, useFeatures } from '@cordata/buffet';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { useParams, Link } from 'react-router-dom';
import { all, spread } from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  adminInstance as axios,
  authorizedInstanceNoBase as axiosFull,
} from '~/utils';

import useApi from '~/utils/api/hook';

import General from '~/components/Provider/GeneralForm';
import Kickstarter from '~/components/Provider/KickstarterForm';

const ProvidersDetails = () => {
  const params = useParams();
  const [data, setData] = useState({});
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [tab, setTab] = useState(0);
  const { hasAppKickstarter } = useFeatures();
  const { api } = useApi();

  const tabs = [{
    name: 'General',
    form: General,
    isActive: true,
  }, {
    name: 'Kickstarter',
    form: Kickstarter,
    isActive: hasAppKickstarter,
  }];

  useEffect(() => {
    axios
      .get(`/provider/${params.provider_id}`)
      .then(r => all([
        r,
        axiosFull.get(r.data.data.relationships.person.related),
        axiosFull.get(r.data.data.relationships.providerLocations.related),
        axiosFull.get(r.data.data.relationships.user.related),
        axiosFull.get(r.data.data.relationships.providerSignatures.related),
      ]))
      .then(spread((r, ...rest) => {
        // eslint-disable-next-line no-param-reassign
        r.data.data.relationships.person = rest[0].data.data;
        // eslint-disable-next-line no-param-reassign
        r.data.data.relationships.providerLocations = rest[1].data.data;
        // eslint-disable-next-line no-param-reassign
        r.data.data.relationships.user = rest[2].data ? rest[2].data.data : {};
        // eslint-disable-next-line no-param-reassign
        r.data.data.relationships.providerSignatures = rest[3].data.data;

        return r;
      }))
      .then(r => setData(r.data.data))
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  }, []);

  return (
    <>
      {!isLoading && !error ? (
        <>
          <PageTitle
            action={<>
              {data.attributes.userUid && (
                <Button
                  outline
                  tag={Link}
                  to={`/admin/users/${data.attributes.userUid}`}
                  color="primary"
                >
                  Go to user record
                  <FontAwesomeIcon icon="external-link-alt" className="ml-2" />
                </Button>
              )}
            </>}
          >
            {`${data.relationships.person.attributes.lastName}, ${data.relationships.person.attributes.firstName}`}
          </PageTitle>

          <Nav tabs>
            {tabs.filter(t => t.isActive).map((t, i) => (
              <NavItem key={`{${t.name}-${t.name}`}>
                <NavLink
                  className={classnames({ active: tab === i })}
                  onClick={() => { setTab(i); }}
                  style={{ cursor: 'pointer' }}
                  disabled={tab === i}
                >
                  {t.name}
                </NavLink>
              </NavItem>
              ))}
          </Nav>

          <TabContent activeTab={tab}>
            {tabs.filter(t => t.isActive).map((t, i) => (
              <TabPane tabId={i} key={t.name}>
                <t.form
                  data={data}
                  api={api}
                />
              </TabPane>
              ))}
          </TabContent>

        </>
      ) : (
        <PseudoStates isLoading={isLoading} data={data} error={error} />
      )}
    </>
  );
};

export default ProvidersDetails;
